import React, { useContext, useEffect, useState } from "react";

import { HotelQuantityPicker } from "../hotelQuantityPicker";
import { HotelCalendar } from "../Calendar/HotelCalendar";
import { HotelSearchContext, HotelSearchContextType } from "../../../contexts/HotelSearchContext";
import { HotelSearchRoom } from "../../../types/HotelType";
import { DatesSearchContext, DatesSearchContextType } from "../../../contexts/DatesSearchContext";
import styles from "./SearchForm.module.scss";
import { differenceInDays, format } from "date-fns";
import { CartAPI } from "../../../api/CartAPI";
import { DataLayerAPI } from "../../../api/DataLayerAPI";
import { HotelsSearchRoomsContext, HotelsSearchRoomsContextType } from "../../../contexts/HotelSearchRoomsContextWrapper";
import { nothing } from "immer";


type SearchFormProps = {
  onSubmit: (dates:Date[], hotelSearchRooms: HotelSearchRoom[], cartAPI?: CartAPI) => void;
  cartAPI?: CartAPI;
  setTabIndex?: (index: number) => void;
  pageName:string;
}

const dataLayerApi = new DataLayerAPI()

export function SearchForm({onSubmit, cartAPI, setTabIndex, pageName}:SearchFormProps ) {
  const { hotelSearchRooms, setHotelSearchRooms, } = useContext<HotelSearchContextType>(HotelSearchContext);
  const { datesSearch,setDatesSearch } = useContext<DatesSearchContextType>(DatesSearchContext);
  const { setFilteredHotels } = useContext<HotelsSearchRoomsContextType>(HotelsSearchRoomsContext);
  const [ roomInformationText, setRoomInformationText ] = useState<string>( '' );
  const [ buttonLoading, setButtonLoading ] = useState<boolean>( false );
  const [ isComponentLoaded,setIsComponentLoaded ] = useState<boolean>(false);

  const formattedDate = datesSearch.map(date => format(date, 'dd/MM/yyyy'))

  const isStayLong = (date: Date[]) => {
    return (differenceInDays(date[1], date[0]) > 21) ? false : true
  }

  const onDateChange = (dates: Date[]) => {
    saveDatesToLocalStorage(dates);
    setDatesSearch(dates);
  };

  function saveDatesToLocalStorage(dates: Date[]) {
    if (typeof window !== 'undefined') {
      localStorage.setItem('chosenDates', JSON.stringify(dates));
    }
  }

  const handleToggleClick = (toShow: boolean, setToShow: React.Dispatch<React.SetStateAction<boolean>>) => {
    setToShow(!toShow);
  };

  const resetSearch = (dates: Date[], cartAPI?: CartAPI) => {
    if (dates.length > 0 || localStorage.length > 0 || cartAPI) {
      setButtonLoading(true);
      cartAPI?.clear();
      setTabIndex && setTabIndex(0);
      localStorage.removeItem('chosenDates');
      localStorage.removeItem('romsData');
      setDatesSearch([]);
      setHotelSearchRooms([]);
      onSubmit([],[]);
      setFilteredHotels([])
    }
  }

  useEffect(() => {
    setRoomInformationText(hotelSearchRooms && hotelSearchRooms.map((room, index) => {
      return room.adultsQty === 0 && room.childrenQty === 0 && room.infantsQty === 0 ?
        'Add guest(s) & room(s)' :
        `Room ${index + 1} - ${room.adultsQty > 0 ? `${room.adultsQty} × Adults ` : ''}
          ${room.childrenQty > 0 ? `${room.childrenQty} × Children ` : ''}
          ${room.infantsQty > 0 ? `${room.infantsQty} × Infants` : ''}`;
    }).join(', '));
  setButtonLoading(false);
  } ,[hotelSearchRooms]);

  useEffect(() => {
    if (typeof window != undefined) setIsComponentLoaded(true)
  },[])

  const searchButton = 'Search';
  let titleHeading = 'Your Universal accommodation';
  let whenHeading = 'When are you staying?';
  let whoHeading = 'Who is staying?';

  // The full/collapsed setting for search panel
  const [ showDetails, setShowDetails ] = useState<boolean>(true);

  // If there's a date, default to collapsed on page load
  // as we're assuming the search is done
  // (mainly for less noise on rooms page)

    useEffect(() => {
      if (formattedDate.length > 1) setShowDetails(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

  return (
    <div className={showDetails ? `${styles.main} ${styles.showSearch}` : `${styles.main} ${styles.hideSearch}` } >
      <div className={styles.searchHeadingSection}>
        <h2 className={styles.searchHeading}>{titleHeading}</h2>
        <div className={styles.bookingSectionTop}>
          <div className={styles.calendarSectionTop}>
            <h3 className={`${styles.searchSub} ${styles.when}`}>{whenHeading}</h3>
            {roomInformationText && formattedDate.length > 1 && (
                <span className={`${styles.subSub} ${styles.when}`}><a className={styles.searchBarTop} onClick={() => handleToggleClick(showDetails, setShowDetails)} href='#na'><strong>{formattedDate.join(' - ')} </strong><em>Edit</em></a></span>
            )}
          </div>
          <div className={styles.guestSectionTop}>
            <h3 className={`${styles.searchSub} ${styles.who}`}>{whoHeading}</h3>
            {roomInformationText && formattedDate.length > 1 && (
                <span className={`${styles.subSub} ${styles.who}`}><a className={styles.searchBarTop} onClick={() => handleToggleClick(showDetails, setShowDetails)} href='#na'><strong>{roomInformationText} </strong><em>Edit</em></a></span>
            )}
          </div>
        </div>
      </div>
      <a className={styles.searchBar} onClick={() => handleToggleClick(showDetails, setShowDetails)} href='#na'>
        {roomInformationText && formattedDate.length > 1 ? (
          <>
            <span className={styles.date}>{formattedDate.join(' - ')}</span>
            <span className={styles.guests}>{roomInformationText}</span>
            <span className={styles.edit}>EDIT</span>
          </>
        ):
        <>
          <span className={styles.date}>Add dates</span>
          <span className={styles.guests}>Add Travellers & Rooms</span>
          <span className={styles.edit}>EDIT</span>
        </>
        }
      </a>
          <div className={styles.bookingSection}>
            <div className={styles.calendarSection}>
              <h3 className={`${styles.sub} ${styles.when}`}>{whenHeading}</h3>
          {isComponentLoaded && <HotelCalendar isStayLong={isStayLong} onChange={onDateChange} dates={datesSearch} formattedDate={formattedDate} />}
            </div>
            <div className={styles.guestSection}>
            <h3 className={`${styles.sub} ${styles.who}`}>{whoHeading}</h3>
              {isComponentLoaded  && <HotelQuantityPicker /> }
            <div className={styles.buttonsSection}>
              { !buttonLoading ? <button className={styles.btnAlt} onClick={() => [resetSearch(datesSearch, cartAPI)]}>Reset</button> : <button disabled className={styles.btn}>Loading...</button>}

              <button
                disabled={datesSearch.length > 1 && isStayLong(datesSearch) ? false : true}
                onClick={() => [onSubmit(datesSearch,hotelSearchRooms, cartAPI), handleToggleClick(showDetails, setShowDetails), dataLayerApi.logSearchFormSubmit(hotelSearchRooms,datesSearch,pageName)]}
                className={styles.btn}>
                  {searchButton}
              </button>
            </div>
            </div>
          </div>
    </div>
  );
}
